// The "Match is now live" card (snippets/live-banner.liquid). By the visitor's clock, every minute: the latest game
// that has started and is less than three hours old is live; on a day with several games the next one takes over when
// it starts. Games known only by date never count as live. Closing the card hides it for that game (this visit).
// The button goes to the game's biggest English stream (`stream` in the Upcoming matches list, from the feed), or to
// its HLTV match page when there is none.
import { $, session, motion, decode, setText } from 'fx';

const LIVE_FOR = 3 * 3600e3;
const startOf = (m) => (m.startsAt ? Date.parse(m.startsAt) : Number(m.at) * 1000);

// pick-live:start
export function pickLive(list, now) {
  let live = null;
  let liveAt = -Infinity;
  for (const m of Array.isArray(list) ? list : []) {
    if (!m || m.timePrecision === 'date') continue;
    const at = startOf(m);
    if (Number.isFinite(at) && at <= now && now < at + LIVE_FOR && at > liveAt) {
      live = m;
      liveAt = at;
    }
  }
  return live;
}
// pick-live:end

const box = $('#live');
if (box) {
  const keyOf = (m) => `${startOf(m)}|${m.opponent || ''}`;
  let shown = '';

  const render = () => {
    let list = [];
    try { list = JSON.parse(($('#live-matches') || {}).textContent || '[]'); } catch { list = []; }
    const m = pickLive(list, Date.now());
    if (!m || session.get('9ine-live-closed') === keyOf(m)) {
      box.hidden = true;
      shown = '';
      return;
    }
    if (shown === keyOf(m)) return;
    shown = keyOf(m);
    setText($('[data-live-opp]', box), m.opponent || '');
    setText($('[data-live-event]', box), m.event ? ` · ${m.event}` : '');
    // Where to watch: the match's own stream (the biggest English one, from the feed), else its HLTV match page.
    const link = $('[data-live-link]', box);
    link.href = m.stream || m.url || '#';
    link.hidden = link.getAttribute('href') === '#';
    if (m.stream && m.streamName) link.setAttribute('aria-label', `${link.textContent.trim()}: ${m.streamName}`);
    else link.removeAttribute('aria-label');
    box.hidden = false;
    if (motion) {
      box.classList.add('is-entering');
      requestAnimationFrame(() => requestAnimationFrame(() => box.classList.remove('is-entering')));
      decode($('.live-title', box), { delay: 250, step: 24, hold: 160 });
    }
  };

  $('[data-live-close]', box).addEventListener('click', () => {
    session.set('9ine-live-closed', shown);
    box.hidden = true;
  });

  render();
  setInterval(render, 60e3);
  // Lets the theme editor (and a test) ask for a fresh look without waiting for the next minute.
  document.addEventListener('live:check', render);
}
